// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNav-cls1_Myc","cls2":"FocusedNav-cls2_zYS FocusedNav-cls1_Myc"};